var OverlayController = (function ($) {
  
  var win, root, overlay;
  
  function ready() {
    win = $(window);
    root = $("#root");
    
    overlay = $("<div id='overlay' />");
    root.prepend(overlay);
    
    overlay.on('click', onOverlayClick);
    
    // if ($('html').hasClass('touch')) {
    //   overlay.on('touchend', onOverlayTouchEnd);
    // }
  }
  
  function onOverlayClick(e) {
    e.preventDefault();
    $(OverlayController).trigger('overlayClick');
  }
  
  function onOverlayTouchEnd(e) {
    e.preventDefault();
    $(OverlayController).trigger('overlayClick');
  }
  
  function hide() {
    overlay.stop(true, false).fadeOut(250, 'easeInOutExpo');
  }
  
  function show() {
    overlay.stop(true, false).fadeIn(250, 'easeInOutExpo');
  }
  
  $(ready);
  
  return {
    show: show,
    hide: hide
  };
  
})(jQuery);